import orgTree from './orgTree'

const zhCN = { orgTree: orgTree.zhCN }
const enUS = { orgTree: orgTree.enUS }
export default { zhCN, enUS }